module.exports = "/images/download-icon.svg?3246be4ae0f72c96cf6e2db05073d203";